import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 10001,
	},
	modal: {
		backgroundColor: '#fff',
		borderRadius: 8,
		boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
		width: 400,
		maxWidth: '90vw',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		color: '#282828',
		margin: 0,
	},
	input: {
		fontSize: 14,
		padding: '10px 12px',
		border: '1px solid #D3D3D3',
		borderRadius: 4,
		outline: 'none',
		width: '100%',
		boxSizing: 'border-box' as const,
		':focus': {
			borderColor: '#00AAE8',
		},
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
	},
	cancelButton: {
		padding: '8px 16px',
		fontSize: 14,
		fontWeight: 500,
		borderRadius: 4,
		border: '1px solid #D3D3D3',
		backgroundColor: '#fff',
		color: '#282828',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f9fafb',
		},
	},
	renameButton: {
		padding: '8px 16px',
		fontSize: 14,
		fontWeight: 500,
		borderRadius: 4,
		border: 'none',
		backgroundColor: '#00AAE8',
		color: '#fff',
		cursor: 'pointer',
		':hover': {
			opacity: 0.9,
		},
	},
});
